<template>
  <div>
    <template v-if="false">
      <div>{{ currentPageIndex }}</div>
      <div>{{ previousPageTokens }}</div>
      <div> previousToken:     {{ previousPageTokens[currentPageIndex] }}</div>
      <div> nextToken:     {{ nextPageToken }}</div>
    </template>
    <div
      class="youtube-btn-wrap">
      <div
        v-if="selectedAsset"
        class="youtube-search-wrap"
        style="margin-bottom: 22px;">
        <label>
          選択中のアセット:
          <b>{{ selectedAsset.metadata.title }}({{ selectedAsset.id }})</b>
        </label>
        <a
          href="#"
          class="c-text-link"
          @click.prevent="onAssetRowClicked('')">
          選択を解除
        </a>
      </div>
      <div
        v-else
        class="youtube-search-wrap"
        style="margin-bottom: 22px;">
        <input
          v-model="keyword"
          class="youtube-search"
          placeholder="楽曲名、ISRC、アーティスト名"
          type="search"
          @search="onClickedSearch('', $event)"
          @keydown.prevent.enter="onClickedSearch('enter', $event)">
        <a
          class="c-btn c-btn--search"
          @click.prevent="onClickedSearch('',$event)">
          <img src="/img/common/icon-search.png" />検索
        </a>
      </div>
    </div>
    <template v-if="!loading">
      <asset-table
        v-if="!selectedAsset && assets.length > 0"
        :items="assets"
        select-button-text="申し立て動画"
        @row-clicked="onAssetRowClicked" />
      <claim-table
        v-if="selectedAsset && claims.length > 0"
        :items="claims"
        @row-clicked="onClaimRowClicked" />
      <div
        v-else-if="errorMessage"
        class="error-message">
        {{ errorMessage }}
      </div>
      <div
        style="margin-top: 12px;display: flex; justify-content: space-between;">
        <a
          v-if="previousPageTokens[currentPageIndex]"
          class="c-btn c-btn--narrow"
          @click.prevent="onPreviousPageClicked">
          前の10件を表示
        </a>
        <span v-else></span>
        <a
          v-if="nextPageToken"
          class="c-btn c-btn--narrow"
          @click.prevent="onNextPageClicked">
          次の10件を表示
        </a>
        <span v-else></span>
      </div>
    </template>
  </div>
</template>

<script>
import YouTubeClaimsClaimTable from './ClaimTable'
import YouTubeAssetsAssetTable from '../../Assets/AssetTable'

export default {
  name: 'YouTubeClaimsAssetSearch',
  components: {
    ClaimTable: YouTubeClaimsClaimTable,
    AssetTable: YouTubeAssetsAssetTable,
  },
  props: {
    inputKeyword: {
      type: String,
      required: false,
      default: '',
    },
    inputAssetId: {
      type: String,
      required: false,
      default: '',
    },
    defaultPageIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      loading: true,
      type: 1,
      keyword: '',
      assets: [],
      claims: [],
      currentPageIndex: 0,
      nextPageToken: null,
      error: null,
      errorMessage: null,
      selectedAsset: null,
    }
  },
  computed: {
    previousPageTokens: {
      set(value) {
        window.sessionStorage.setItem('youtube-claims-asset-search-previous-page-tokens', JSON.stringify(value))
      },
      get() {
        try {
          return JSON.parse(window.sessionStorage.getItem('youtube-claims-asset-search-previous-page-tokens') ?? '{}')
        } catch (e) {
          return {}
        }
      },
    },
  },
  watch: {
    inputKeyword: {
      immediate: true,
      handler(value) {
        this.keyword = value
        if (value) {
          this.fetchItems(value)
        }
      },
    },
    defaultPageIndex: {
      immediate: true,
      handler(value) {
        this.currentPageIndex = value
        this.nextPageToken = this.previousPageTokens[value] ?? null
      },
    },
    inputAssetId: {
      immediate: true,
      handler(value) {
        if (value) {
          this.fetchAsset(value)
          this.fetchVideoByAssetId(value, this.nextPageToken)
        }
      },
    },
  },
  mounted() {
    this.previousPageTokens = {}
  },
  methods: {
    onClickedSearch(type, event) {
      if (type === 'enter' && event.keyCode !== 13) {
        return
      }
      this.$emit('change', this.keyword)
      if (this.keyword === '' || this.keyword === null) {
        this.assets = []
        this.selectedAsset = null
        return
      }
      this.fetchItems(this.keyword, true)
    },
    async onAssetRowClicked(id) {
      this.$emit('select-asset', id)
      this.nextPageToken = null
      this.previousPageTokens = {}
      this.currentPageIndex = 0
      if (id === '') {
        this.selectedAsset = null
        this.claims = []
        return
      }
      await this.fetchAsset(id)
      await this.fetchVideoByAssetId(id)
    },
    async fetchItems(keyword) {
      this.loading = true
      this.errorMessage = null
      this.assets = []
      this.selectedAsset = null
      this.error = null
      try {
        // 検索結果を取得
        const { data } = await window.axios.get('/api/client/youtube/assets/search', {
          params: {
            keyword,
          },
        })
        this.assets = data

        if (!this.assets || this.assets.length === 0) {
          this.errorMessage = '検索結果が見つかりませんでした'
        }
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.assets = []
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
      this.loading = false
    },
    async fetchAsset(assetId) {
      try {
        // 検索結果を取得
        const { data } = await window.axios.get(`/api/client/youtube/assets/${assetId}`)
        this.selectedAsset = data.asset
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.selectedAsset = null
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
    },
    async fetchVideoByAssetId(assetId, nextPageToken = null) {
      this.loading = true
      // this.nextPageToken = null
      try {
        // 検索結果を取得
        const { data } = await window.axios.get('/api/client/youtube/claims/search', {
          params: {
            asset_id: assetId,
            next_page_token: nextPageToken,
          },
        })
        const { items, next_page_token: newNextPageToken } = data
        this.claims = items
        if (nextPageToken) {
          const tokens = this.previousPageTokens
          tokens[this.currentPageIndex] = nextPageToken
          this.previousPageTokens = tokens
        }
        this.$emit('change-pagination', { pageIndex: this.currentPageIndex })
        this.$nextTick(() => {
          this.$set(this, 'nextPageToken', newNextPageToken)
        })
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.claims = []
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
      this.loading = false
    },
    onPreviousPageClicked() {
      this.currentPageIndex -= 1
      this.fetchVideoByAssetId(
        this.selectedAsset.id,
        this.previousPageTokens[this.currentPageIndex],
      )
    },
    onNextPageClicked() {
      this.currentPageIndex += 1
      this.fetchVideoByAssetId(this.selectedAsset.id, this.nextPageToken)
    },
    onClaimRowClicked(id) {
      this.$emit('row-clicked', id)
    },
  },
}
</script>

<style scoped>
.error-message {
  color: #ff0000;
  font-size: 16px;
  margin: 20px auto 120px 20px;
  text-align: left;
}
</style>
